import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SimpleLabel } from '../domain/simple_label.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SimpleLabelService {
  private apiUrl = environment.apiUrl + '/api/v1/simple/labels';

  constructor(private http: HttpClient) { }

  getAll(): Observable<SimpleLabel[]> {
    return this.http.get<SimpleLabel[]>(this.apiUrl);
  }

  incrementCounter(id: number, incrementValue: number): Observable<void> {
    const params = new HttpParams().set('incrementValue', incrementValue.toString());
    return this.http.post<void>(`${this.apiUrl}/${id}/increment`, null, { params });
  }

  printLabels(id: number, from: number, to: number): Observable<ArrayBuffer> {
    const params = { from: from.toString(), to: to.toString() };
    const headers = new HttpHeaders({ 'Accept': 'application/pdf' });
    return this.http.get<ArrayBuffer>(`${this.apiUrl}/${id}/print`, { params, headers, responseType: 'arraybuffer' as 'json' });
  }
  
}
